import React from 'react';
import {ErrorBoundary as SentryErrorBoundary} from '../../../Services/Sentry';

const ErrorBoundary = ({ children }) => {

    const fallback = <div className="rounded-xl bg-red-50 text-red-700 p-4 border border-red-700"
        onClick={() => window.location.reload()}
    >
        <p className="font-bold mb-2">Sorry, an error occurred 😞</p>
        <p>Tap here to reload and try again.</p>
    </div>

    return <SentryErrorBoundary showDialog fallback={fallback}>
        {children}
    </SentryErrorBoundary>
}

export default ErrorBoundary;